module.exports = __webpack_public_path__ + "static/media/house.6253174d.svg";